import { defineMessages } from '../i18n/messages';

export const LocaleSelectorMessages = defineMessages({
  LABEL: {
    id: 'locale_selector.label',
    text: 'Language',
    description: 'Locale selector accessible label',
  },
  SEARCH_PLACEHOLDER: {
    id: 'locale_selector.search_placeholder',
    text: 'Search...',
    description:
      'Placeholder in the filter box at the top of the open language menu. Typing narrows the list of locales. Kept generic because the list is matched on both the English and the native language name.',
  },
});